import PropTypes from 'prop-types';

import {
  useEffect,
  useRef
} from 'react';
import { SkeletonText } from '@febos-io/design';
import ReceivingMessage from './ReceivingMessage';

export function Chat({ loading, messages, withIcon }) {
  const lastItemRef = useRef(null);

  useEffect(() => {
    if (lastItemRef.current) {
      lastItemRef.current.focus();
    }
  }, [messages]);

  return (
    <div
      className="row mb-1 overflow-auto border bg-gray-100 rounded shadow-sm"
      data-mdb-perfect-scrollbar="true"
      style={{
        position: 'relative',
        minHeight: '35vh',
        maxHeight: '50vh',
        flexDirection: (loading && !messages.length) ? 'column' : 'column-reverse'
      }}
    >
      <ul className="list-unstyled">
        {loading && !messages.length && (
          <>
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
          </>
        )}
        {messages.map((message, index) => (
          <ReceivingMessage
            ref={index === messages.length - 1 ? lastItemRef : null}
            withIcon={withIcon}
            message={message}
            key={message.id}
          />
        ))}
      </ul>
    </div>
  );
}

Chat.propTypes = {
  messages: PropTypes.array,
  withIcon: PropTypes.bool,
  loading: PropTypes.bool
};

export default Chat;
